"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = require("react-dom");
var Root_1 = __importDefault(require("./container/Root"));
var appRoot = document.getElementById('app-view');
if (appRoot) {
    (0, react_dom_1.render)(react_1.default.createElement(Root_1.default, null), appRoot);
}
